module.exports = __webpack_public_path__ + "static/img/devices.ddd8202.svg";